import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../../../models/Dashboard/Analytics";
import dayjs from "dayjs";
import DashboardAnalyticsAPI from "../../api/dashboards/DashboardAnalyticsAPI";
import { DashboardAPIFilters } from "../../../../models/Dashboard/DashboardFilters";

export class DashboardAnalyticsStore {
  analyticsAPI: DashboardAnalyticsAPI;
  churn_tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new DashboardAnalyticsAPI();
    this.churn_tats = [];

    makeObservable(this, {
      churn_tats: observable,
      getChurnTats: action,
    });
  }

  getChurnTats = async (filters: DashboardAPIFilters) => {
    try {
      filters.start_date = dayjs(filters.start_date, "YYYY-MM-DD").format(
        "YYYY-MM-DD HH:mm:ss"
      );

      filters.end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .subtract(1, "second")
        .format("YYYY-MM-DD HH:mm:ss");

      filters.date = dayjs(filters.date, "YYYY-MM-DD")
        .add(1, "day")
        .subtract(1, "second")
        .format("YYYY-MM-DD HH:mm:ss");

      const data = (await this.analyticsAPI.getChurnTats(
        "/tats/churn",
        filters
      )) as LabelValue[];
      this.churn_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
